import React from "react";

interface ItemCountProps {
  stock: number;
  initialStock: number;
}

const ItemCount = ({ stock, initialStock }) => {
  return (
    <div className="flex flex-col items-center mt-[67px]">
      <p className="text-auctionMid">Items left</p>
      <p className="font-bold text-[34px]">{`${stock}/${initialStock}`}</p>
    </div>
  );
};

export default ItemCount;
